import { ApiRequestModel } from "../../models/api_request_model";

//export class CustomDataByRequestedType {
//  public DisplayName: string;
//  public SearchName: string;
//  public Code: number;
//}
export class CustomCodeValuesController {
  public DisplayName: string;
  public SearchName: string;
  public Code: number;
  public IsSelected: boolean;
}

export class CustomCodeTypeRequest {
  public RequestedType: string;
  public FacilityCode: number;
  public CodeType: string;
  public ActorCode: number;
  public CustomCode: number; // Cusotm Code fror Getting Custom data based on some condition.. for a function...
  public CustomType: string;
  public StringContains: string;
  //public TestCode: number;
  public MedicineCode: number; // SHOULD NEVER USE>>MISTAKE.
    public SendApiRequestModel: ApiRequestModel;
    
}
